import React, { Component, Fragment } from 'react';
import ZoneList from 'Components/CourierLineItemsTable/ZoneList';
import ResponsiveTable from 'Components/ResponsiveTable';
import { Status } from 'Components/Status';
import { ReactComponent as AcceptIcon } from 'Icons/checked.svg';
import { ReactComponent as RejectIcon } from 'Icons/reject.svg';
import Input from 'Components/Input';
import { CHALLENGE_PRICE_SENT } from 'Constants/commonConstants';

class CourierLineItemsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            zonePriceList : [],
            otherCharges : props.otherCharges && [...props.otherCharges] || [],
            otherChargePriceList : [],
            // additionalZoneList: props.additionalZoneList && [...props.additionalZoneList] || []
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps.otherCharges.length && !this.state.otherCharges.length) {
            this.setState({ otherCharges: [...nextProps.otherCharges]});
        } else if(JSON.stringify(nextProps.otherCharges) !== JSON.stringify(this.props.otherCharges)) {
            this.setState({ otherCharges: [...nextProps.otherCharges]});
        }
        // if(nextProps.additionalZoneList.length && !this.state.additionalZoneList.length) {
        //     this.setState({ additionalZoneList: [...nextProps.additionalZoneList]});
        // } else if(JSON.stringify(nextProps.additionalZoneList) !== JSON.stringify(this.props.additionalZoneList)) {
        //     this.setState({ additionalZoneList: [...nextProps.additionalZoneList]});
        // }
    }

    postBidAll = (type) => {
        const  { acceptOrRejectLoiList } = this.props;
        if(acceptOrRejectLoiList.length > 0) {
            this.props.postBidAll(type, acceptOrRejectLoiList);
        }
    }

    onPriceChange = (list , id) => {
		const { zonePriceList } = this.state;
        zonePriceList[id] = list;
		this.setState({ zonePriceList });
    }

    onSaveBidPrice = (id, isCommonCharges) => {
        const { zonePriceList } = this.state;
        const { lineItems } = this.props;
        const data = [];
        let isError = false;
        if(zonePriceList[id] && Array.isArray(zonePriceList[id])) {
            (zonePriceList[id] || []).forEach(zlist => {
                if(zlist.price && zlist.tat) {
                    data.push({
                        rfq_id: lineItems[0].rfqId,
                        trip_id: zlist.trip_id,
                        max_tat: zlist.tat && +zlist.tat || 0.0,
                        price: zlist.price && +zlist.price || 0.0
                    })
                } else if((!zlist.price && zlist.tat) || (zlist.price && !zlist.tat)) {
                    isError = true;
                }
            })
        } else if(isCommonCharges && id) {
            data.push({
                rfq_id: lineItems[0].rfqId,
                trip_id: zonePriceList[id].trip_id,
                other_charge_id: zonePriceList[id].other_charge_id,
                max_tat: zonePriceList[id].tat && +zonePriceList[id].tat || 0.0,
                price: zonePriceList[id].price && +zonePriceList[id].price || 0.0
            })
        }
        if(isError) {
            alert('Please Enter Price And TAT');
            return;
        } else if(data.length) {
            this.props.courierPostBid(data);
        }
    }

    onSaveEachBidPrice = (zonePriceList, isAdditionalZone) => {
        const { lineItems } = this.props;
        this.props.courierPostBid([{
            rfq_id: lineItems[0].rfqId,
            trip_id: zonePriceList[isAdditionalZone && 'id' || 'trip_id'],
            max_tat: zonePriceList.tat && +zonePriceList.tat || 0.0,
            price: zonePriceList.price && +zonePriceList.price || 0.0
        }]);
    }

	handleChallengePrice = (type, item) => {
		if (type === 'accept') {
			this.props.postChallengePrice(item.id, {
                price: Number(item.challengePrice),
                ip_address: localStorage.getItem('IPAddress'),
                type: 0,
				tat: {
					unit: item.tat.tatUnit.unit,
					value: Number(item.tat.tatValue),
					name: item.tat.tatUnit.tatUnitName
				}
			});
			this.props.acceptRejectCP(item.id, true);
		} else {
			this.props.acceptRejectCP(item.id, false);
		}
    }
    
    saveListOfObjects = (data, CPData) => {
        this.props.setAcceptOrRejectLoiList(data, CPData);
    }

    acceptZoneClicked = (e, isAllZone, name, fromZone, id) => {
        const { lineItems ,systemTime, acceptOrRejectLoiList,  acceptOrRejectCPList} = this.props;
        let selectedData = [...acceptOrRejectLoiList];
        let selectedCPData = [...acceptOrRejectCPList];
        if(e.target.checked) {
            (lineItems || []).forEach(lineItem => {
                const zoneFrom = (fromZone ? (lineItem.zoneName === name && lineItem.id === id) : true)
                if(zoneFrom) {
                    (lineItem.zoneList || []).forEach(list => {
                        if(((isAllZone || fromZone) ? true : list.zone_to === name) && list.loi_accept_valid_to >= systemTime && list.is_loi_sent && !list.is_accept) {
                            const zoneInd = (selectedData || []).findIndex(selData => selData.trip_id === list.trip_id);
                            if(zoneInd < 0) {
                                selectedData.push({
                                            trip_id: list.trip_id,
                                            is_loi_with_cp_sent: list.is_loi_with_cp_sent,
                                            challenge_price: list.challenge_price
                                        })
                            }
                        }
                        if(((isAllZone || fromZone) ? true : list.zone_to === name) && list.challenge_price && list.cp_state === CHALLENGE_PRICE_SENT && !list.is_accept) {
                            const zoneInd = (selectedCPData || []).findIndex(selData => selData.trip_id === list.trip_id);
                            if(zoneInd < 0){
                                selectedCPData.push({
                                    rfq_id: lineItem.rfqId,
                                    trip_id: list.trip_id,
                                    price: list.challenge_price,
                                    type: 0,
                                    tat: list.tat
                                })
                            }
                        }
                    })
                }
            })
        } else {
            (lineItems || []).forEach(lineItem => {
                const zoneFrom = (fromZone ? (lineItem.zoneName === name && lineItem.id === id) : true)
                if(zoneFrom) {
                    (lineItem.zoneList || []).forEach(list => {
                        if(((isAllZone || fromZone) ? true : list.zone_to === name) && list.loi_accept_valid_to >= systemTime && list.is_loi_sent && !list.is_accept) {
                            const zoneInd = (selectedData || []).findIndex(selData => selData.trip_id === list.trip_id);
                            if(zoneInd >= 0) {
                                selectedData.splice(zoneInd, 1);
                            }
                        }
                        if(((isAllZone || fromZone) ? true : list.zone_to === name) && list.challenge_price && list.cp_state === CHALLENGE_PRICE_SENT && !list.is_accept) {
                            const zoneInd = (selectedCPData || []).findIndex(selData => selData.trip_id === list.trip_id);
                            if(zoneInd >= 0) {
                                selectedCPData.splice(zoneInd, 1);
                            }
                        }
                    })
                }
            })
        }
        this.saveListOfObjects(selectedData, selectedCPData);
    } 

    loiChecked = (name, isfrom, id) => {
        let selectedLoi = 0;
        let listCount = 0;
        let listCPCount = 0;
        let selectedCPLoi = 0;
        const { lineItems , systemTime, acceptOrRejectLoiList, acceptOrRejectCPList} = this.props;

        (lineItems || []).forEach(cItem => {
            const fromFlag = isfrom ? (cItem.zoneName === name && cItem.id === id) : true;
            if(fromFlag) {
                (cItem.zoneList || []).forEach(cZItem => {
                    const toFlag = !isfrom ? cZItem.zone_to === name : true;
                    if(toFlag && cZItem.is_loi_sent && !cZItem.is_accept && (cZItem.loi_accept_valid_to >= systemTime)) {
                        listCount += 1;
                        const findZone = acceptOrRejectLoiList.findIndex(aRlist => aRlist.trip_id === cZItem.trip_id);
                        if(findZone >= 0) {
                            selectedLoi += 1;
                        }
                    }
                    if(toFlag && cZItem.challenge_price && cZItem.cp_state === CHALLENGE_PRICE_SENT && !cZItem.is_accept) {
                        listCPCount += 1;
                        const findZone = acceptOrRejectCPList.findIndex(aRlist => aRlist.trip_id === cZItem.trip_id);
                        if(findZone >= 0) {
                            selectedCPLoi += 1;
                        }
                    }
                })
            }
        })
        return ((listCount && selectedLoi && (selectedLoi === listCount)) || (selectedCPLoi && (listCPCount === selectedCPLoi)));
    }

    getAdditionalAllSelect = () => {
        const { additionalZoneList, acceptOrRejectLoiList, acceptOrRejectCPList, systemTime } = this.props;
        let TripCP = 0;
        let TripLoi = 0;
        const allTrips = additionalZoneList.map(item => {
            const tripZone = item.zoneList;
            if(tripZone && tripZone.challenge_price && tripZone.cp_state === CHALLENGE_PRICE_SENT && !tripZone.is_accept) {
                TripCP += 1;
            }
            if(tripZone && tripZone.loi_accept_valid_to >= systemTime && tripZone.is_loi_sent && !tripZone.is_accept) {
                TripLoi += 1;
            }
            return item.id
        });
        const selectedCP = acceptOrRejectCPList.filter(cpList => allTrips.includes(cpList.trip_id));
        const selectedLoi = acceptOrRejectLoiList.filter(loiList => allTrips.includes(loiList.trip_id));
        return (selectedCP.length || selectedLoi.length) && (selectedCP.length === TripCP || selectedLoi.length === TripLoi );
    }

    selectAddtionalZones = (e, trip) => {
        const tripZone = trip.zoneList || '';
        const { acceptOrRejectLoiList, acceptOrRejectCPList, systemTime } = this.props;
        if(tripZone && tripZone.loi_accept_valid_to >= systemTime && tripZone.is_loi_sent && !tripZone.is_accept) {
            const zIndex = acceptOrRejectLoiList.findIndex(aRLOI => aRLOI.trip_id === tripZone.trip_id);
            if(zIndex > -1) {
                acceptOrRejectLoiList.splice(zIndex, 1);
            } else {
                acceptOrRejectLoiList.push({
                    trip_id: tripZone.trip_id,
                    is_loi_with_cp_sent: tripZone.is_loi_with_cp_sent,
                    challenge_price: tripZone.challenge_price
                })
            }
        }
        if(tripZone && tripZone.challenge_price && tripZone.cp_state === CHALLENGE_PRICE_SENT && !tripZone.is_accept) {
            const zIndex = acceptOrRejectCPList.findIndex(aRCP => aRCP.trip_id === tripZone.trip_id);
            if(zIndex > -1) {
                acceptOrRejectCPList.splice(zIndex, 1);
            } else {
                acceptOrRejectCPList.push({
                    rfq_id: trip.rfqId,
                    trip_id: tripZone.trip_id,
                    price: tripZone.challenge_price,
                    type: 0,
                    tat: tripZone.tat
                })
            }
        }
        this.saveListOfObjects(acceptOrRejectLoiList, acceptOrRejectCPList);
    }

    acceptAdditionalZoneClicked = (e) => {
        const { acceptOrRejectLoiList, acceptOrRejectCPList, systemTime, additionalZoneList } = this.props;
        additionalZoneList.map(zone => {
            const tripZone = zone.zoneList;
            const loiIndex = acceptOrRejectLoiList.findIndex(aRLoi => aRLoi.trip_id === tripZone.trip_id);
            const cpIndex = acceptOrRejectCPList.findIndex(aRCP => aRCP.trip_id === tripZone.trip_id);
            if(e.target.checked) {
                if(loiIndex === -1 && tripZone.loi_accept_valid_to >= systemTime && tripZone.is_loi_sent && !tripZone.is_accept) {
                    acceptOrRejectLoiList.push({
                        trip_id: tripZone.trip_id,
                        is_loi_with_cp_sent: tripZone.is_loi_with_cp_sent,
                        challenge_price: tripZone.challenge_price
                    })
                }
                if(cpIndex === -1 && tripZone.challenge_price && tripZone.cp_state === CHALLENGE_PRICE_SENT && !tripZone.is_accept) {
                    acceptOrRejectCPList.push({
                        rfq_id: zone.rfqId,
                        trip_id: tripZone.trip_id,
                        price: tripZone.challenge_price,
                        type: 0,
                        tat: tripZone.tat
                    })
                }
            } else {
                if(loiIndex > -1) {
                    acceptOrRejectLoiList.splice(loiIndex, 1);
                }
                if(cpIndex > -1) {
                    acceptOrRejectCPList.splice(cpIndex, 1);
                }
            }
        })
        this.saveListOfObjects(acceptOrRejectLoiList, acceptOrRejectCPList);
    }

    render() {
        const {  
                courierZones,
                biddingStage,
                lineItems,
                acceptOrRejectLoiList,
                isRilCPForm,
                postChallengePrice,
                acceptRejectCP,
                acceptOrRejectCPList,
                fetchBids,
                tripBids,
                isCourierTermAccepted,
                additionalZoneList
            } = this.props;

        const {
            courierTrips,
            otherCharges
        } = this.state;
        let count = 0 ;
        const columnZones = lineItems && lineItems.length > 0 && lineItems[0].zoneList || [];
        return(
            <Fragment>
            <ResponsiveTable className="ph-10 pv-10">
                <div className="courier-table">
                    <table className='col-1' cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                {biddingStage['complete'] && 
                                <th rowspan="2" width="25" className="first">
                                    <input
                                        type="checkbox" 
                                        name="acceptorrejectlois" 
                                        checked={((acceptOrRejectLoiList.length > 0 && (acceptOrRejectLoiList.length === (lineItems.reduce((sum,lI) => {
                                            return sum + ((lI.zoneList ||[]).filter(zne => { return (zne.is_loi_sent && !zne.is_accept)}).length);
                                        }, 0)))) || (acceptOrRejectCPList.length > 0 && (acceptOrRejectCPList.length === (lineItems.reduce((sum,lI) => {
                                            return sum + ((lI.zoneList ||[]).filter(zne => { return (zne.challenge_price && zne.cp_state === CHALLENGE_PRICE_SENT && !zne.is_accept)}).length);
                                        }, 0)))))}
                                        onClick={(e) => { e.stopPropagation(); this.acceptZoneClicked(e, true) }} 
                                    />
                                </th>}
									  <th rowspan="2" width="100" className={biddingStage['complete'] ? "second" : "first "}>Zone</th>
									  <th rowspan="2" className={biddingStage['complete'] ? "first-col text-data third" : "first-col text-data second_inprogress"} width="100">Movement Type </th>
									  <th rowspan="2" width="75" className={biddingStage['complete'] ? "fourth-col" : "third_inprogress"}>Mode Type</th>
									  <th rowspan="2" width="75" className={biddingStage['complete'] ? "fifth-col" : "fourth-progress"}>Slab</th>

                                {(columnZones|| []).map((list, lIndex) => {
                                    return(
                                        <Fragment>
                                            <th colspan="5"> {list.zone_to}</th>
                                        </Fragment>
                                    )
                                })}
                                {biddingStage['inProgress'] && isCourierTermAccepted && <th  width="50">Actions</th>}
                            </tr>
                            {/* <tr> */}
                                {(columnZones || []).map((list, lIndex) => {
                                    return (
                                    // <td key={`priceHeader_${lIndex}`}>
                                    //     <table cellpadding="0" cellspacing="0">
                                    //     <tr>
                                    <Fragment>
                                        <th width="75">QBR</th>
                                        <th width="75">Max TAT</th>
                                        <th width="75">Bid Price</th>
                                        <th width="75">TAT</th>
                                        {(biddingStage['inProgress'] ||  biddingStage['complete']) && <th width="100">
                                            {biddingStage['complete'] && 
                                                <input 
                                                    type="checkbox" 
                                                    name="acceptorrejectlois"
                                                    checked={(acceptOrRejectLoiList.length > 0 || acceptOrRejectCPList.length > 0) && this.loiChecked(list.zone_to, false)} 
                                                    onClick={(e) => { e.stopPropagation(); this.acceptZoneClicked(e, false, list.zone_to) }} 
                                                />}
                                            Status
                                        </th>}
                                    </Fragment>
                                    //     </tr>

                                    // </table>
                                    // </td>
                                    )
                                })}
                                {biddingStage['inProgress'] && <th></th>}
                            {/* </tr> */}
                        </thead>
                        <tbody>
                            {
                                (lineItems || []).map((courier, courierIndex) => {
                                    return(
                                        <tr className="firt-row" key={`courier_${courierIndex}`}>
                                            {biddingStage['complete'] && 
															<th width="25" className="first">
                                                <input 
                                                    type="checkbox" 
                                                    name="acceptorrejectlois" 
                                                    checked={(acceptOrRejectLoiList.length > 0 || acceptOrRejectCPList.length > 0) && this.loiChecked(courier.zoneName, true, courier.id)} 
                                                    onClick={(e) => { e.stopPropagation(); this.acceptZoneClicked(e, false, courier.zoneName, true, courier.id) }} 
                                                />
                                            </th>}
														<th className={biddingStage['complete'] ? "second" :"first "}>
                                                {courier.zoneName}
                                            </th>
														<td className={biddingStage['complete'] ? "text-data third" : "text-data second_inprogress"}>
                                                {courier.movementName}
                                            </td>
														<td className={biddingStage['complete'] ? "text-data fourth-col" : " text-data third_inprogress"}>
                                                {courier.modeName}
                                            </td>
														<td className={biddingStage['complete'] ? "text-data slab fifth-col" : "text-data slab fourth-progress"}>
                                                {courier.slabs && `${courier.slabs.from} - ${courier.slabs.to}`}
                                            </td>
                                            {
                                                <ZoneList 
                                                    courierZones= {columnZones}
                                                    id={courier.id}
                                                    zoneList={courier.zoneList}
                                                    onChange = {this.onPriceChange}
                                                    biddingStage={biddingStage}
                                                    systemTime={this.props.systemTime}
                                                    acceptOrRejectLoiList={acceptOrRejectLoiList}
                                                    acceptOrRejectCPList={acceptOrRejectCPList}
                                                    saveListOfObjects={this.saveListOfObjects}
                                                    postBidAll={this.props.postBidAll}
                                                    isRilCPForm={isRilCPForm}
                                                    acceptRejectCP={acceptRejectCP}
                                                    postChallengePrice={postChallengePrice}
                                                    onSaveEachBidPrice={this.onSaveEachBidPrice}
                                                    rfqId={courier.rfqId}
                                                    fetchBids={fetchBids}
                                                    tripBids={tripBids}
													isCourierTermAccepted={isCourierTermAccepted}
													/>
											  }
                                            {(biddingStage['inProgress']) && isCourierTermAccepted && <td className="text-data" style={{ borderRight: '1px solid'}}>
                                                <button className="theme-color fBold" onClick={() => this.onSaveBidPrice(courier.id)}>Save</button>
                                            </td>}
														{biddingStage['complete'] && lineItems[courierIndex].challengePrice && 
															lineItem[courierIndex].challengePrice !== 0 && lineItem[courierIndex].challengePrice < lineItem[courierIndex].price &&
																 <td><React.Fragment>
															<AcceptIcon className="wt-20 ht-20 ml-5 curP z-100" onClick={() => this.handleChallengePrice('accept', lineItem[courierIndex])} />
															<RejectIcon className="wt-20 ht-20 ml-5 curP z-100" onClick={() => this.handleChallengePrice('reject', lineItem[courierIndex])} />
														</React.Fragment></td>}
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </ResponsiveTable>

            {additionalZoneList && additionalZoneList.length > 0 &&
            <ResponsiveTable className="pv-10 ph-10 mt-20">
                <div className="courier-table">
                    <table className='col-1' cellpadding="0" cellspacing="0">
                    <thead>
                            <tr>
                                {biddingStage['complete'] &&
                                <th width="25">
                                    <input
                                        type="checkbox" 
                                        name="acceptorrejectlois" 
                                        checked={(acceptOrRejectLoiList.length > 0 || acceptOrRejectCPList.length > 0) && this.getAdditionalAllSelect()}
                                        onClick={(e) => { e.stopPropagation(); this.acceptAdditionalZoneClicked(e) }} 
                                    />
                                </th>}
                                <th>Zone From</th>
                                <th>Zone To</th>
                                <th>Movement Type </th>
                                <th>Mode Type</th>
                                <th>Slab</th>
                                <th>QBR</th>
                                <th>Max TAT</th>
                                <th>Bid Price</th>
                                <th>TAT</th>
                                {(biddingStage['inProgress'] ||  biddingStage['complete']) && 
                                <th>
                                    Status
                                </th>}
                                {biddingStage['inProgress'] && isCourierTermAccepted && <th width="100">Actions</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {(additionalZoneList || []).map((aZone, aZIndex) => {
                                return(
                                    <tr className="firt-row" key={`aZone_${aZIndex}`}>
                                    {biddingStage['complete'] && 
                                    <th width="25" className="first">
                                        <input 
                                            type="checkbox" 
                                            name="acceptorrejectlois" 
                                            checked={(acceptOrRejectLoiList.length > 0 || acceptOrRejectCPList.length > 0) && (acceptOrRejectLoiList.find(aRList => aRList.trip_id === aZone.id) ||  acceptOrRejectCPList.find(aRCPList => aRCPList.trip_id === aZone.id) )} 
                                            onClick={(e) => { 
                                                e.stopPropagation(); 
                                                this.selectAddtionalZones(e, aZone);
                                            }} 
                                        />
                                    </th>}
                                    <th className={biddingStage['complete'] ? "second" :"first "}>
                                        {aZone.zoneName}
                                    </th>
                                                <td className={biddingStage['complete'] ? "text-data third" : "text-data second_inprogress"}>
                                        {aZone.zoneList && aZone.zoneList.zone_to}
                                    </td>
                                    <td className={biddingStage['complete'] ? "text-data third" : "text-data second_inprogress"}>
                                        {aZone.movementName}
                                    </td>
                                    <td className={biddingStage['complete'] ? "text-data fourth-col" : " text-data third_inprogress"}>
                                        {aZone.modeName}
                                    </td>
                                        <td className={biddingStage['complete'] ? "text-data slab fifth-col" : "text-data slab fourth-progress"}>
                                        {aZone.slabs && `${aZone.slabs.from} - ${aZone.slabs.to}`}
                                    </td>
                                    {
                                        <ZoneList 
                                            courierZones= {aZone.zoneList && [aZone.zoneList]}
                                            id={aZone.id}
                                            zoneList={aZone.zoneList && [aZone.zoneList]}
                                            onChange = {this.onPriceChange}
                                            biddingStage={biddingStage}
                                            systemTime={this.props.systemTime}
                                            acceptOrRejectLoiList={acceptOrRejectLoiList}
                                            acceptOrRejectCPList={acceptOrRejectCPList}
                                            saveListOfObjects={this.saveListOfObjects}
                                            postBidAll={this.props.postBidAll}
                                            isRilCPForm={isRilCPForm}
                                            acceptRejectCP={acceptRejectCP}
                                            postChallengePrice={postChallengePrice}
                                            onSaveEachBidPrice={this.onSaveEachBidPrice}
                                            rfqId={aZone.rfqId}
                                            fetchBids={fetchBids}
                                            tripBids={tripBids}
                                            isCourierTermAccepted={isCourierTermAccepted}
                                            // isAdditionalZone={true}
                                            lineItemSave={true}
                                            />
                                      }
                                    {(biddingStage['inProgress']) && isCourierTermAccepted && <td className="text-data" style={{ borderRight: '1px solid'}}>
                                        <button className="theme-color fBold" onClick={() => this.onSaveBidPrice(aZone.id)}>Save</button>
                                    </td>}
                                </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </ResponsiveTable>}

            <ResponsiveTable className="pv-10 ph-10 mt-20">
                <div className="courier-table">
                    <table className='col-1' cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th colspan="7">Common Charges</th>
                            </tr>
                            <tr>
                                <th>Description</th>
                                <th>Movement Type</th>
                                <th>Mode Type</th>
                                <th>QBR</th>
                                <th>Bid Price</th>
                                {biddingStage['inProgress'] && <th>Actions</th>}
                            </tr>
                        </thead>
                        
                        {(otherCharges || []).map((oCharge, oCIdx) => {
                            return(<tbody>
                                <tr>
                                    <td className="text-data">{oCharge.description}</td>
                                    <td className="text-data">{oCharge.movement_name}</td>
                                    <td className="text-data">{oCharge.mode_name}</td>
                                    <td className="text-data">{oCharge.other_charge_cost}</td>
                                    <td className="text-data">
                                        <Input 
                                        value={oCharge.price}
                                        type="number" 
                                        name="price" 
                                        placeHolder="Price"
                                        className="tCenter"
                                        onChange={(e) => {
                                            const { value, name } = e.target;
                                            const { otherCharges } = this.state;
                                            otherCharges[oCIdx][name] = value ? +value : value;
                                            this.setState({ otherCharges }, () => {
                                                this.onPriceChange(this.state.otherCharges[oCIdx],oCharge.trip_id);
                                            });
                                        }} 
													 disabled={!this.props.isCourierTermAccepted}/>
                                    </td>
                                    {/* {biddingStage['inProgress'] &&  <td className="text-data">
                                        <Status 
                                            status={oCharge.status && {
                                                statusText: oCharge.status.status_text,
                                                colorCode: oCharge.status.color_code
                                            } || {}}
                                            hideText={true}
                                        />
                                    </td>} */}
                                    {biddingStage['inProgress'] && 
                                    <td className="text-data" style={{ borderRight: '1px solid'}}>
                                        <button className="theme-color fBold" onClick={() => this.onSaveBidPrice(oCharge.trip_id, true)}>Save</button>
                                    </td>}
                                </tr>
                            </tbody>)})
                        }
                    </table>
                </div>
            </ResponsiveTable>
            </Fragment>
        )
    }
}

export default CourierLineItemsTable;